import { AppSettings, AppSettingsService } from '@cgs/machines';
import { Container, EventDispatcher, EventStream } from '@cgs/wge';

export interface CorsicaAppSettings extends AppSettings {}

export class CorsicaAppSettingsService extends AppSettingsService<CorsicaAppSettings> {
  private readonly gameSettingsChangedDispatcher = new EventDispatcher<CorsicaAppSettings>();

  public readonly onGameSettingsChanged: EventStream<CorsicaAppSettings> =
    this.gameSettingsChangedDispatcher.eventStream;

  constructor(container: Container) {
    super(container);

    // const _launchParams = container.resolve<TrifectaLaunchParamsDto>(TRIFECTA_TRIFECTA_LAUNCH_PARAMS_TOKEN);
  }
}
